
export function emitChatMessage(message, conversationId) {
  return {
    type: 'EMIT_CHAT_MESSAGE',
    message,
    conversationId,
    meta: {
      sendServer: true,
    }
  };
}

export const openChatPanel = (conversationId, isOpen = true) => ({type: 'OPEN_CHAT_PANEL', conversationId, isOpen}) 
export const toggleChatPanel = conversationId => ({type: 'TOGGLE_CHAT_PANEL', conversationId}) 
export const reduceChatPanel = conversationId => ({type: 'REDUCE_CHAT_PANEL', conversationId}) 
export const closeChatPanel = conversationId => ({type: 'CLOSE_CHAT_PANEL', conversationId}) 

// BACKEND
export function pushChatMessage(data) {
  return {
    type: 'PUSH_CHAT_MESSAGE',
    id: data.id,
    conversationId: data.conversationId,
    message: data.message,
    messageLocaleKey: data.messageLocaleKey,
    extraData: data.extraData,
    date: data.date,
    userHandlerId: data.userHandlerId,
    messageType: data.messageType,
    meta: {
      sendClient:true,
    }
  };
}

export function pushChatMessageList(messages) {
  return {
    type: 'PUSH_CHAT_MESSAGE_LIST',
    messages,
  };
}